export default "__VITE_ASSET__Bwp_zb$I__"